import "./partnerBenefits.scss";

export default function PartnerBenefits(props: {
  benefits: {
    tag?:string;
    iconUrl: string;
    title: string;
    content: string;
  }[];
}) {
  function checkIsLastItemInArrayByIndex(arrayLength: number, index: number) {
    if (index < arrayLength - 1) {
      return false;
    } else {
      return true;
    }
  }

  return (
    <>
      {props.benefits.length > 0 && (
        <div className="partner-benefits-list-wrap">
          <ul className="benefits-list"
            // className={`
            //   benefits-list
            //   ${props.benefits.length > 1 ? "multiple" : ""}
            // `}
          >
            {props.benefits.map((item, idx) => (
              <BenefitItem
                key={idx}
                tag={item?.tag || '캐시백'}
                iconUrl={item.iconUrl}
                title={item.title}
                content={item.content}
                // isLastItem={checkIsLastItemInArrayByIndex(props.benefits.length, idx)}
              />
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

function BenefitItem(props: {
  tag:string;
  iconUrl: string;
  title: string;
  content: string;
  // isLastItem?: boolean;
}) {
  return (
    <li className="benefit-item">
      <div className="info-wrap">
        <div className="benefit-tag">{props.tag}</div>
        <div className="title-box">
          {/* <i style={{ backgroundImage: `url(${props.iconUrl})` }} /> */}
          <p>{props.title}</p>
          <p>{props.content}</p>
        </div>
      </div>

      {/* {props.isLastItem === false && (
        <div className="coupon-divider-ui">
          <div className="line" />
        </div>
      )} */}
    </li>
  );
}
